import updatePostNumbers from './update-post-numbers-info';
import buildModal from './build-modal';

export default function processResults(data, settings) {
	// Transition delay
	const transition = 600;

	// Get data count 
	const postCount = data.post_count;

	// Get insert class
	const insertClass = data.insert;

	// Class of the element to animate
	const cardClass = settings.card;
	const cardAnimateClass = `${cardClass}--animate`;
	const cardDynamicClass = `${cardClass}--dynamic`;

	// Add additional dynamic classes that are used for animation
	const tempContainerEl = document.createElement('div');
	tempContainerEl.innerHTML = data.content;
	Array.from(tempContainerEl.querySelectorAll(`.${cardClass}`)).forEach(
		(el) => {
			el.classList.add(cardDynamicClass, cardAnimateClass);
		}
	);
	data = tempContainerEl.innerHTML;

	// Insert new posts into the page
	if (settings.card !== 'ed-career-card') {
		const insert = settings.rootEl.querySelector(
			insertClass
		);
	
		const insertParent = insert.parentNode;
		insertParent.insertAdjacentHTML('beforeend', data);
	} else {
		const insertParent = document.getElementById(
			'ed-block-careers-archive__grid'
		);
		insertParent.insertAdjacentHTML('beforeend', data);
	}

	// Update post numbers
	updatePostNumbers(settings.rootEl, settings.card, settings.totalCount, settings.btn);

	// Select new elements
	const newElements = Array.from(
		settings.rootEl.querySelectorAll(cardAnimateClass)
	);

	// Add an incrementally larger transition delay to new elements
	for (let i = 0; i < newElements.length; i++) {
		newElements[i].setAttribute(
			'style',
			'transition-delay:' + '0.1' * i + 's'
		);
	}

	// Animate the cards by removing the dynamic class that we just added
	setTimeout(function () {
		settings.rootEl
			.querySelectorAll('.' + cardClass + '--dynamic')
			.forEach((el) => {
				el.classList.remove(cardClass + '--dynamic');
			});
	}, transition);

	setTimeout(function () {
		newElements.forEach((el) => {
			//Remove the animation delay class so that the animation will work for the next set of cards
			el.classList.remove(cardClass + '--animate');
			//Removing the animation delay so that it doesnt effect the hover effect
			el.setAttribute('style', 'transition-delay:' + '0' + 's');
			// Adds a click event so the new cards can display a modal
			el.addEventListener('click', function () {
				buildModal({
					postID: parseInt(el.dataset.id, 10),
					postType: 'organisation',
				});
			});
		});
	}, transition * 3);
}